import Vue from 'vue';
import VueRouter from 'vue-router';
import { isEmpty } from 'lodash';
import store from '@/store';
import Login from '../views/login/Login.vue';
import Forgot from '../views/login/Forgot.vue';
import Recover from '../views/login/Recover.vue';
import PrivacyPolicy from '../views/privacy/PrivacyPolicy.vue';
import MfaVerify from '../views/login/MfaVerify.vue';
// import Sended from '../views/login/Sended.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/mfa-verify',
    name: 'MfaVerify',
    component: MfaVerify,
  },
  {
    path: '/forgot-password',
    name: 'Forgot',
    component: Forgot,
  },
  {
    path: '/policy',
    name: 'Policy',
    component: PrivacyPolicy,
  },
  {
    path: '/policies',
    name: 'Policies',
    component: PrivacyPolicy,
  },
  {
    path: '/recover-password/:token',
    name: 'Recover',
    component: Recover,
  },
  {
    path: '/new-user',
    name: 'CreateUser',
    component: () => import('../views/users/components/AddUserSidebar.vue'),
  },
  {
    path: '/update-user/:id',
    name: 'UpdateUser',
    components: {
      default: () => import('../views/users/Users.vue'),
      sidebar: () => import('../views/users/components/AddUserSidebar.vue'),
    },
  },
  {
    path: '/update-facility/:id',
    name: 'UpdateFacility',
    components: {
      default: () => import('../views/company/company.vue'),
      sidebar: () => import('../views/company/components/FacilitiesSidebar.vue'),
    },
  },
  {
    path: '/update-location/:id',
    name: 'UpdateLocation',
    components: {
      default: () => import('../views/company/company.vue'),
      sidebar: () => import('../views/company/components/LocationsSidebar.vue'),
    },
  },
  {
    path: '/detector/:id',
    name: 'Detector',
    components: {
      default: () => import('../views/company/company.vue'),
      sidebar: () => import('../views/company/components/AssignDetectorSidebar.vue'),
    },
  },
  {
    path: '/Update-detector/:id',
    name: 'UpdateDetector',
    components: {
      default: () => import('../views/company/company.vue'),
      sidebar: () => import('../views/company/components/FacilitiesSidebar.vue'),
    },
  },
  {
    path: '/inventory',
    name: 'Inventory',
    component: () => import('../views/company/company.vue'),
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('../views/users/Users.vue'),
  },
  {
    path: '/company',
    name: 'company',
    component: () => import('../views/company/company.vue'),
  },
  {
    path: '/settings',
    name: 'settings',
    // component: () => import('../views/settings/Settings.vue'),
    component: () => import('../views/new-settings/NewSettings.vue'),
  },
  {
    path: '/upgrades',
    name: 'upgrades',
    component: () => import('../views/upgrades/Upgrades.vue'),
  },
  {
    path: '/logs',
    name: 'logs',
    component: () => import('../views/logs/Logs.vue'),
  },
  {
    path: '/factory',
    name: 'factory',
    component: () => import('../views/factory/Factory.vue'),
  },
  {
    path: '/matrix',
    name: 'matrix',
    component: () => import('../views/matrix-compatibility/Matrix.vue'),
  },
  {
    path: '/accept-invite',
    name: 'AcceptInvite',
    component: () => import('../views/login/AcceptInvite.vue'),
  },
  { path: '*', redirect: '/users' },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/', '/login', '/recover-password', '/forgot-password', '/email-sended', '/disable-alert', '/policy', '/mfa-verify', '/accept-invite'];
  const path = `/${to.path.split('/')[1]}`;
  const authRequired = !publicPages.includes(path);
  const loggedIn = !isEmpty(store.state.user);

  if (path === '/recover-password') {
    store.commit('setPrevRoute', from.path);
    return next();
  }

  if (authRequired && !loggedIn) {
    return next('/login');
  }

  if (!authRequired && loggedIn) {
    return next('/company' || '/inventory');
  }

  store.commit('setPrevRoute', from.path);
  return next();
});

export default router;
